import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appFocusOnErrorField]',
  standalone: true,
})
export class FocusOnErrorFieldDirective {

  constructor(private el: ElementRef) { }

  @HostListener('ngSubmit')
  onFormSubmit() {
    const invalidControl = this.el.nativeElement.querySelector('.ng-invalid');

    if (invalidControl) {
      invalidControl.focus();  
    }
  }

}
